// SYNCED FROM: VidaReactNative/src/apis/lobApi.ts — keep in sync. See SYNC.md.
import axios from 'axios';

import { LOB_API_BASE_URL, LOB_PUBLISHABLE_KEY } from '../constants/lob';

export type LobVerifyRequest = {
  primary_line: string;
  secondary_line?: string;
  city?: string;
  state?: string;
  zip_code?: string;
};

export type LobDeliverability =
  | 'deliverable'
  | 'deliverable_unnecessary_unit'
  | 'deliverable_incorrect_unit'
  | 'deliverable_missing_unit'
  | 'undeliverable';

export type LobVerifyResponse = {
  primary_line: string;
  secondary_line: string;
  last_line: string;
  deliverability: LobDeliverability;
  components: {
    primary_number?: string;
    street_predirection?: string;
    street_name?: string;
    street_suffix?: string;
    street_postdirection?: string;
    secondary_designator?: string;
    secondary_number?: string;
    pmb_designator?: string;
    pmb_number?: string;
    extra_secondary_designator?: string;
    extra_secondary_number?: string;
    city: string;
    state: string;
    zip_code: string;
    zip_code_plus_4: string;
  };
  deliverability_analysis?: {
    dpv_footnotes?: string[];
  };
};

// Dedicated instance: Lob is an external service authed with the publishable
// key, NOT the Vida bearer — so it must not go through the shared apiClient.
const lobAxios = axios.create({
  baseURL: LOB_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  auth: { username: LOB_PUBLISHABLE_KEY, password: '' },
  timeout: 5000,
});

export const verifyUsAddress = async (req: LobVerifyRequest): Promise<LobVerifyResponse> => {
  // Fail fast with a clear message if the publishable key is missing, rather than
  // firing a request with empty Basic-auth and surfacing a fuzzy 401 in the dialog.
  if (!LOB_PUBLISHABLE_KEY) {
    throw new Error('LOB_PUBLISHABLE_KEY is not configured');
  }
  const response = await lobAxios.post<LobVerifyResponse>('/us_verifications', req, {
    params: { case: 'proper' },
  });
  return response.data;
};
